const storageKey = (restaurantSlug) => `voucher_${restaurantSlug}`;

/** Normalize API voucher payload (camelCase or PascalCase). */
export function normalizeVoucher(raw) {
    if (!raw || typeof raw !== "object") return null;
    const code = raw.voucherCode ?? raw.Voucher_Code ?? "";
    const pct = Number(raw.discountPercentage ?? raw.Voucher_DiscountPercentage ?? 0);
    const amount = Number(raw.discountAmount ?? raw.DiscountAmount ?? 0);
    return {
        ...raw,
        voucherId: raw.voucherId ?? raw.Voucher_ID,
        voucherCode: String(code).trim(),
        voucherName: raw.voucherName ?? raw.Voucher_Name ?? "",
        discountPercentage: pct,
        discountAmount: amount,
        minimumOrderAmount:
            Number(raw.minimumOrderAmount ?? raw.Voucher_MinimumOrderTotalAmount ?? 0) || 0,
        isValid: raw.isValid !== false,
    };
}

/** Discount for a given items subtotal (recalculates % vouchers when total changes). */
export function computeVoucherDiscount(voucher, orderSubtotal) {
    const v = normalizeVoucher(voucher);
    if (!v) return 0;
    const subtotal = Number(orderSubtotal) || 0;
    if (subtotal <= 0) return 0;
    if (v.discountPercentage > 0) {
        return (subtotal * v.discountPercentage) / 100;
    }
    return Math.max(0, v.discountAmount);
}

export function getStoredVoucher(restaurantSlug) {
    if (!restaurantSlug || typeof window === "undefined") return null;
    try {
        const raw = sessionStorage.getItem(storageKey(restaurantSlug));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const code = parsed?.code ?? parsed?.voucherCode;
        const voucher = normalizeVoucher(parsed?.voucher ?? parsed);
        if (!code && !voucher?.voucherCode) return null;
        return {
            code: String(code || voucher.voucherCode).trim(),
            voucher,
        };
    } catch {
        return null;
    }
}

export function setStoredVoucher(restaurantSlug, code, voucher) {
    if (!restaurantSlug || typeof window === "undefined") return;
    const normalized = normalizeVoucher(voucher);
    if (!normalized) return;
    sessionStorage.setItem(
        storageKey(restaurantSlug),
        JSON.stringify({ code: String(code || normalized.voucherCode).trim(), voucher: normalized })
    );
}

export function clearStoredVoucher(restaurantSlug) {
    if (!restaurantSlug || typeof window === "undefined") return;
    sessionStorage.removeItem(storageKey(restaurantSlug));
}
